<template>
  <div class="page-container">
    <a-page-header class="page-header" @back="back">
      <div slot="title" style="cursor: pointer" @click="back">
        返回
        <span>工作台/</span>
        <span class="header-title">心理辅导</span>
      </div>
    </a-page-header>
    <TableList
      style="min-height: 80vh"
      :columns="tabPaneConfig[0].columns"
      :tableData="tabPaneConfig[0].tableData"
      :loading="tabPaneConfig[0].loading"
      :scroll="{ x: true }"
      :pagination="tabPaneConfig[0].pagination"
      @change="handleTableChange"
    >
      <div slot="queryArea" style="margin-bottom: 20px">
        <!--        <a-select-->
        <!--          v-model="queryParam.appointmentType"-->
        <!--          placeholder="预约类型"-->
        <!--          :options="appointmentTypeOptions"-->
        <!--          style="width: 150px; margin-right: 15px"-->
        <!--        />-->
        <!--        <j-dict-select-tag-->
        <!--          style="width: 170px; margin-right: 15px"-->
        <!--          placeholder="请选择年级"-->
        <!--          v-model="queryParam.gradeId"-->
        <!--          identityGet="gradeDict"-->
        <!--          :isShowEmpty="false"-->
        <!--          @select="$set(queryParam, 'classId', undefined)"-->
        <!--        />-->
        <!--        <j-dict-select-tag-->
        <!--          style="width: 170px; margin-right: 15px"-->
        <!--          placeholder="请选择班级"-->
        <!--          v-model="queryParam.classId"-->
        <!--          :identityGet="`classDict,${queryParam.gradeId}`"-->
        <!--          :async="true"-->
        <!--          :disabled="!queryParam.gradeId"-->
        <!--          :isShowEmpty="false"-->
        <!--        />-->
        <!--        <a-range-picker-->
        <!--          v-model="rangeDate"-->
        <!--          style="width: 220px; margin-right: 15px"-->
        <!--          @change="changeDateRange"-->
        <!--        />-->
        <!--        <j-dict-select-tag-->
        <!--          v-model="queryParam.careList"-->
        <!--          placeholder="关爱等级"-->
        <!--          dictCode="care_list"-->
        <!--          style="width: 140px; margin-right: 15px"-->
        <!--        />-->
        <a-input-search
          v-model="queryParam.name"
          placeholder="请输入学生名称"
          style="width: 170px; margin-right: 15px"
          @change="searchName"
        />
        <a-button type="primary" @click="queryTable">查询</a-button>
        <!-- <a-button type="primary" icon="plus">新增</a-button> -->
        <!--        <a-button type="primary" icon="download" style="margin: 0 15px" @click="handleExportXls">-->
        <!--          导出-->
        <!--        </a-button>-->
      </div>
      <div slot="psychologyIssues" slot-scope="{ record }">
        {{ getDictCodeData('emotional_type', record.psychologyIssues).text }}
      </div>
      <div slot="tutoringType" slot-scope="{ record }">
        {{ getDictCodeData('tutoring_type', record.tutoringType).text }}
      </div>
      <div slot="remark" slot-scope="{ record }">
        <a-tooltip>
          <template slot="title">
            {{ record.remark }}
          </template>
          {{ record.remark.length > 20 ? record.remark.substring(0, 20) + '...' : record.remark }}
        </a-tooltip>
      </div>
      <template slot="action" slot-scope="{ record }">
        <div class="action-detail">
          <span
            :style="{ color: record?.warnStatus == 5 ? '#0077fa' : '#9FCCF6' }"
            @click="reported(record)"
          >
            上报
          </span>
          <a-divider type="vertical" />
          <span @click="homeSchoolCom(record)">家校沟通</span>
          <a-divider type="vertical" />
          <span
            :style="{
              color: record?.warnStatus == 3 || record?.warnStatus == 4 ? '#0077fa' : '#9FCCF6',
            }"
            @click="mentoringRecord(record)"
          >
            辅导记录
          </span>
          <a-divider type="vertical" />
          <a-popconfirm
            v-if="record?.warnStatus == 2"
            title="是否确认预约"
            @confirm="confirmReservation(record)"
            @cancel="() => {}"
          >
            <span style="color: #0077fa">确认预约</span>
          </a-popconfirm>
          <span v-else style="color: #9fccf6">确认预约</span>
          <a-divider type="vertical" />
          <span @click="viewArchives(record)">查看档案</span>
        </div>
      </template>
    </TableList>
    <!-- 对话框 -->
    <ReportModal ref="reportModalRef" @refreshData="loadData" />
    <SchoolHomeComModal ref="schoolHomeComModalRef" />
    <MentoringRecordModal ref="mentoringRecordModalRef" @refreshData="loadData" />
  </div>
</template>
<script>
import TableList from '@/components/chart/TableList'
import { getAction, postAction } from '@api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getDictCodeData, simpleDebounce, openNewTabPage } from '@/utils/util'
import moment from 'moment'
import Vue from 'vue'
import { IDENTITY_ID } from '@/store/mutation-types'
import ReportModal from '@/comUi/ReportModal.vue'
import SchoolHomeComModal from '@/comUi/SchoolHomeComModal.vue'
import MentoringRecordModal from '@/comUi/MentoringRecordModal.vue'

const tablePagination = {
  current: 1,
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100'],
  showTotal: (total, range) => {
    return range[0] + '-' + range[1] + ' 共' + total + '条'
  },
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
}

// 额外列
const extraColumns = [
  {
    title: '问题原因',
    dataIndex: 'psychologyIssues',
    align: 'center',
    scopedSlots: { customRender: 'psychologyIssues' },
  },
  {
    title: '班主任反馈原因',
    dataIndex: 'tags',
    align: 'center',
  },
  {
    title: '辅导类型',
    dataIndex: 'tutoringType',
    align: 'center',
    scopedSlots: { customRender: 'tutoringType' },
  },
  {
    title: '备注信息',
    dataIndex: 'remark',
    align: 'center',
    scopedSlots: { customRender: 'remark' },
    // 渲染函数只有初始化才有效，后续加入无效
    // customRender: (_, record) => {
    //   const length = record.memo.length > 20
    //   return (
    //     <a-tooltip>
    //       <template slot="title">{record.memo}</template>
    //       {length ? record.memo.substring(0, 20) + '...' : record.memo ? record.memo : '-'}
    //     </a-tooltip>
    //   )
    // },
  },
]

export default {
  name: 'PsychologicalCounseling',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    ReportModal,
    SchoolHomeComModal,
    MentoringRecordModal,
  },
  data() {
    return {
      tabKey: 1,
      queryParam: {
        appointmentType: 0,
      },
      rangeDate: [],
      appointmentTypeOptions: [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '班主任预约',
          value: 1,
        },
        {
          label: '家长预约',
          value: 2,
        },
      ],
      tabPaneConfig: [
        {
          tab: '心理辅导',
          columns: [
            {
              title: '序号',
              dataIndex: 'index',
              align: 'center',
            },
            {
              title: '班级',
              dataIndex: 'className',
              align: 'center',
            },
            {
              title: '学生',
              dataIndex: 'studentName',
              align: 'center',
            },
            {
              title: '关爱等级',
              dataIndex: 'careList',
              align: 'center',
              customRender: (_, record) => {
                return getDictCodeData('care_list', record.careList).text
              },
            },
            // {
            //   title: '提醒次数',
            //   dataIndex: 'semesterWarnNum',
            //   align: 'center',
            // },
            {
              title: '发起时间',
              dataIndex: 'createTime',
              align: 'center',
            },
            // {
            //   title: '预约人',
            //   dataIndex: '',
            //   align: 'center',
            // },
            // {
            //   title: '电话',
            //   dataIndex: '',
            //   align: 'center',
            // },
            // {
            //   title: '预约辅导时间',
            //   dataIndex: '',
            //   align: 'center',
            // },
            {
              title: '操作',
              dataIndex: 'action',
              align: 'center',
              scopedSlots: { customRender: 'action' },
            },
          ],
          tableData: [],
          loading: false,
          pagination: { ...tablePagination },
        },
      ],
      url: {
        list: '/rector/moodRecordAndWarnRecord',
        importExcelUrl: '',
        exportXlsUrl: '/aigoes/studentInfo/exportXls',
      },
      disableMixinCreated: true,
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  created() {
    if (this.$router.history.current.query.type == 8) {
      const columns = this.tabPaneConfig[0].columns
      columns.splice(columns.length - 1, 0, ...extraColumns)
      this.$set(this.tabPaneConfig[0], 'columns', columns)
      console.log('列信息：', this.columns)
    }
    this.loadData()
  },
  methods: {
    getDictCodeData,
    // 分页变化
    handleTableChange(page) {
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', page)
      this.loadData()
    },
    // 查询
    queryTable() {
      console.log('查询条件--', this.queryParam)
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'pagination', { ...tablePagination })
      this.loadData()
    },
    searchName: simpleDebounce(function (event) {
      const name = event.target.value.trim()
      this.$set(this.queryParam, 'name', name)
      this.getTableData()
    }, 500),
    loadData() {
      switch (this.tabKey) {
        case 1:
          this.$set(this.url, 'list', '/rector/moodRecordAndWarnRecord')
          break
      }
      this.getTableData()
    },
    getTableData() {
      let params = {
        dataType: 1,
        userIdentity: Vue.ls.get(IDENTITY_ID),
        type: this.$router.history.current.query.type,
        pageNo: this.tabPaneConfig[this.tabKey - 1].pagination.current,
        pageSize: this.tabPaneConfig[this.tabKey - 1].pagination.pageSize,
        ...this.queryParam,
      }
      this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', true)
      getAction(this.url.list, params)
        .then((res) => {
          if (res.success) {
            const tableData = res.result.records.length
              ? res.result.records.map((item, index) => {
                  const { psychologyIssues, remark, tutoringType } =
                    item.discussList[item.discussList.length - 1]
                  return {
                    ...item,
                    index: index + 1,
                    psychologyIssues,
                    remark: remark.replace('备注信息：', ''),
                    tutoringType,
                  }
                })
              : []
            this.$set(this.tabPaneConfig[this.tabKey - 1], 'tableData', tableData)
            this.$set(this.tabPaneConfig[this.tabKey - 1].pagination, 'total', res.result.total)
          }
        })
        .finally(() => {
          this.$set(this.tabPaneConfig[this.tabKey - 1], 'loading', false)
        })
    },
    changeDateRange(date) {
      this.queryParam.beginDate = date[0] ? moment(date[0]).format('YYYY-MM-DD') : undefined
      this.queryParam.endDate = date[1] ? moment(date[1]).format('YYYY-MM-DD') : undefined
    },
    reported(record) {
      if (record.warnStatus == 5) {
        this.$refs.reportModalRef.showModal(record)
      }
    },
    homeSchoolCom(record) {
      this.$refs.schoolHomeComModalRef.showModal(record)
    },
    mentoringRecord(record) {
      if (record?.warnStatus == 3 || record?.warnStatus == 4) {
        this.$refs.mentoringRecordModalRef.showModal(record)
      }
    },
    async confirmReservation(record) {
      const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', {
        id: record.id,
        warnStatus: 3,
        comment: '已确认预约',
        visible: 1,
      })
      if (res.success) {
        this.$message.success('确认预约成功')
        this.loadData()
      } else {
        this.$message.error('确认预约失败')
      }
      console.log('确认预约：', record)
    },
    viewArchives(record) {
      console.log('查看档案：', record)
      this.$router.push({
        path: '/school/mentalHealth/ArchivesViewPage',
        query: {
          studentId: record.studentId || record.studentNo,
        },
      })
      // openNewTabPage({
      //   path: '/school/mentalHealth/ArchivesViewPage',
      //   query: {
      //     studentId: record.studentId,
      //     pagePath: '/school/mentalHealth/PsychologicalCounseling',
      //     type: this.$router.history.current.query.type,
      //   },
      // })
    },
    back() {
      // /school/mentalHealth/Workbench
      // 替换到这个页面
      this.$router.replace('/school/mentalHealth/Workbench')
    },
  },
}
</script>
<style scoped lang="less">
.page-header {
  padding: 0;
  margin-bottom: 15px;

  /deep/ .ant-page-header-heading-title {
    font-size: 14px;
  }

  .header-title {
    color: #297ede;
    cursor: pointer;
  }
}

.action-detail {
  min-width: 100px !important;
  color: #0077fa !important;
  cursor: pointer !important;
}
</style>
